export class Constants {
    public static readonly DIAGRAM_NAMN = {
        ARSSKADOR_GRAN: 'ARSSKADOR_GRAN',
        ARSSKADOR_TALL: 'ARSSKADOR_TALL',
        TALL_PA_MAGRA_MARKER: 'TALL_PA_MAGRA_MARKER',
        TALL_PA_MELLANMARK: 'TALL_PA_MELLANMARK',
        TALL_PA_BORDIGA_MARKER: 'TALL_PA_BORDIGA_MARKER',
        OSKADAD_TALL: 'OSKADAD_TALL',
        FOREKOMST_RASE: 'FOREKOMST_RASE',
        KONKURRENS_RASE: 'KONKURRENS_RASE',
        FODERPRODUCERANDE: 'FODERPRODUCERANDE'
    };
}
